// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dpiewzmhkxcyknolmxeg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRwaWV3em1oa3hjeWtub2xteGVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM0MjM2ODcsImV4cCI6MjA1ODk5OTY4N30.uzwz1jPMKE8sGsspuyhccTmHe--kj2fQk9AViy3NlWg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);